var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User Identifier Card"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-identifier-card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 56",
    d: "M3.395 5.66504H31.605C31.605 5.66504 33.75 5.66504 33.75 7.81004V27.19C33.75 27.19 33.75 29.335 31.605 29.335H3.395C3.395 29.335 1.25 29.335 1.25 27.19V7.81004C1.25 7.81004 1.25 5.66504 3.395 5.66504Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 433",
    d: "M23.4 14.7H28.365",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 434",
    d: "M23.4 19.6226H28.365",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.76746 15.52C8.76746 16.608 9.19968 17.6515 9.96905 18.4209C10.7384 19.1903 11.7819 19.6225 12.87 19.6225C13.958 19.6225 15.0015 19.1903 15.7709 18.4209C16.5402 17.6515 16.9725 16.608 16.9725 15.52C16.9725 14.4319 16.5402 13.3884 15.7709 12.6191C15.0015 11.8497 13.958 11.4175 12.87 11.4175C11.7819 11.4175 10.7384 11.8497 9.96905 12.6191C9.19968 13.3884 8.76746 14.4319 8.76746 15.52Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.63501 23.6826C7.25339 22.4802 8.16909 21.4561 9.29501 20.7076C10.3561 20.0065 11.5983 19.6295 12.87 19.6226C14.125 19.6226 15.355 19.9976 16.4475 20.7076C17.5734 21.4561 18.4891 22.4802 19.1075 23.6826",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCard);
export default __webpack_public_path__ + "static/media/UserCard.8ab3d8b219a9bea14145e0ffb368cafa.svg";
export { ForwardRef as ReactComponent };